import React from "react";
import ExamPanel from "./ExamPanel";

const introItems = [
  "The test is divided into parts and sections. Each timed section shows its timer and item count on screen.",
  "At the beginning of each part, you will receive instructions that explain what to expect.",
  "Clicking Next confirms your answer and moves you forward. You cannot return to previous questions.",
  "The test uses different English varieties, including British, American, and Australian English.",
  "Do not use browser back, forward, or reload controls during the test.",
];

export default function TestIntroductionPage() {
  return (
    <ExamPanel
      eyebrow="Before you begin"
      title="Test Introduction"
      instructions="This full mock measures the Reading, Writing, Listening, and Speaking skills used in an academic setting."
    >
      <div className="grid gap-3 lg:grid-cols-2">
        {introItems.map((item, index) => (
          <div
            key={item}
            className="flex gap-3 rounded-md border border-slate-200 bg-slate-50 p-4"
          >
            <span className="grid h-7 w-7 shrink-0 place-items-center rounded-md bg-white text-sm font-extrabold text-violet-700 shadow-sm">
              {index + 1}
            </span>
            <p className="text-sm leading-6 text-gray-600">{item}</p>
          </div>
        ))}
      </div>
    </ExamPanel>
  );
}
